var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, ChangeDetectorRef, EventEmitter, Input, IterableDiffers, Output } from '@angular/core';
// export class BasicList {
// 	private _name:string;
// 	last:any;
// 	dragStart:boolean;
// 	dragOver:boolean;
// 	pick:Array<any>;
// 	list:Array<any>;
// 	constructor(name:string) {
// 		this._name = name;
// 		this.last = null;
// 		this.dragStart = false;
// 		this.dragOver = false;
// 		this.pick = new Array<any>();
// 		this.list = [];
// 	}
// 	get name() : string {
// 		return this._name;
// 	}
// }
var DualListComponent = (function () {
    function DualListComponent(differs, cdr) {
        this.differs = differs;
        this.cdr = cdr;
        // static AVAILABLE_LIST_NAME = 'available';
        // static CONFIRMED_LIST_NAME = 'confirmed';
        this.key = typeof this.key !== 'undefined' ? this.key : '_id';
        this.display = typeof this.display !== 'undefined' ? this.display : '_name';
        this.height = typeof this.height !== 'undefined' ? this.height : '100px';
        this.sort = typeof this.sort !== 'undefined' ? this.sort : false;
        this.compare = typeof this.compare !== 'undefined' ? this.compare : undefined;
        this.destinationChange = new EventEmitter();
        this.itemSelected = null;
        this.boolSelected = false;
        this.listSource = [];
        this.listDest = [];
    }
    DualListComponent.prototype.ngOnInit = function () {
        this.listSource = this.source;
        if (typeof this.destination !== 'undefined') {
            this.listDest = this.destination;
        }
    };
    DualListComponent.prototype.addItem = function (item) {
        if (item === void 0) { item = null; }
        var i = 0;
        if (item) {
            i = this.listSource.indexOf(item);
        }
        else {
            item = this.itemSelected;
            i = this.listSource.indexOf(item);
        }
        //console.log("Item: " + JSON.stringify(item) + " index " + i);
        if (i !== -1) {
            //console.log("Saca de source");
            this.listSource.splice(i, 1);
        }
        //console.log("target: " + this.listDest);
        i = this.listDest.indexOf(item);
        if (i === -1) {
            this.listDest.push(item);
            //console.log("Agregar a target");
        }
        this.itemSelected = null;
        //console.log("source: " + JSON.stringify(this.listSource));
        //console.log("destination: " + JSON.stringify(this.listDest));
    };
    DualListComponent.prototype.rmvItem = function (item) {
        if (item === void 0) { item = null; }
        var i = 0;
        if (item) {
            i = this.listDest.indexOf(item);
        }
        else {
            item = this.itemSelected;
            i = this.listDest.indexOf(item);
        }
        //console.log("Item: " + JSON.stringify(item) + " index " + i);
        if (i !== -1) {
            //console.log("Saca de source");
            this.listDest.splice(i, 1);
        }
        //console.log("source: " + this.listSource);
        i = this.listSource.indexOf(item);
        if (i === -1) {
            this.listSource.push(item);
            //console.log("Agregar a source");
        }
        this.itemSelected = null;
        //console.log("source: " + JSON.stringify(this.listSource));
        //console.log("destination: " + JSON.stringify(this.listDest));
    };
    DualListComponent.prototype.isItemSelected = function (list, item) {
        if (list.filter(function (e) { return Object.is(e, item); }).length > 0) {
            return true;
        }
        return false;
    };
    DualListComponent.prototype.selectItem = function (item) {
        this.itemSelected = item;
        //console.log("item selected " + JSON.stringify(item));
    };
    DualListComponent.prototype.selectAll = function (source, target) {
        var len = source.length;
        var i = 0;
        for (; source.length > 0;) {
            var item = source[0];
            i = target.indexOf(item);
            if (i == -1) {
                target.push(item);
            }
            source.slice(0, 1);
        }
    };
    DualListComponent.prototype.selectNone = function (source) {
        source.length = 0;
    };
    DualListComponent.prototype.isAllSelected = function (source) {
        if (source.length === 0) {
            return true;
        }
        return false;
    };
    DualListComponent.prototype.isAnySelected = function (source) {
        if (source.length > 0) {
            return true;
        }
        return false;
    };
    return DualListComponent;
}());
__decorate([
    Input(),
    __metadata("design:type", String)
], DualListComponent.prototype, "key", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], DualListComponent.prototype, "display", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], DualListComponent.prototype, "height", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], DualListComponent.prototype, "sort", void 0);
__decorate([
    Input(),
    __metadata("design:type", Function)
], DualListComponent.prototype, "compare", void 0);
__decorate([
    Input(),
    __metadata("design:type", Array)
], DualListComponent.prototype, "source", void 0);
__decorate([
    Input(),
    __metadata("design:type", Array)
], DualListComponent.prototype, "destination", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], DualListComponent.prototype, "destinationChange", void 0);
DualListComponent = __decorate([
    Component({
        moduleId: module.id,
        selector: 'dual-list',
        templateUrl: 'dual-list.component.html'
    }),
    __metadata("design:paramtypes", [IterableDiffers, ChangeDetectorRef])
], DualListComponent);
export { DualListComponent };
//# sourceMappingURL=dual-list.component.js.map